export enum AUTH_ACTION_TYPE {
  NAVIGATE_TO_SIGN_IN = 'navigate-to-sign-in',
  NAVIGATE_TO_SIGN_UP = 'navigate-to-sign-up',
  NAVIGATE_TO_FORGOT_PASSWORD = 'navigate-to-forgot-password',
  UPDATE_EMAIL = 'update-email',
  UPDATE_PASSWORD = 'update-password',
  UPDATE_NEW_PASSWORD = 'update-new-password',
  UPDATE_IS_PROCESSING = 'update-is-Processing',
  UPDATE_IS_EMAIL_VERIFIED = 'update-is-email-verified',
  UPDATE_COOL_DOWN = 'update-cool-down',
  UPDATE_GOOGLE_LOGIN_IN_PROGRESS = 'update-login-in-progress',
  UPDATE_APPLE_LOGIN_IN_PROGRESS = 'update-apple-login-in-progress',
  UPDATE_HAS_ACCEPTED_TERMS = 'update-has-accepted-terms',
  RESET_FORM_SUCCESS = 'reset-form-success',
  UPDATE_HAS_PASSWORD_RESET_SUCCEEDED = 'update-has-password-reset-succeeded',
  REGISTRATION_COMPLETED = 'registration-completed'
}

export enum PASSWORD_INPUT_MODE {
  REGISTER = 'register',
  RESET = 'reset'
}

export enum CONSENT {
  EVENT_TRACKING = 'event_tracking',
  TERMS_OF_SERVICE = 'terms_of_service',
  PRIVACY_POLICY = 'privacy_policy',
  DATA_PROCESSING = 'data_processing',
  MARKETING_EMAILS = 'marketing_emails'
}

/** OAuth2 grant types used with Auth0 `/oauth/token`. */
export enum AUTH0_OAUTH_GRANT_TYPE {
  REFRESH_TOKEN = 'refresh_token'
}
